import React from "react";

/**
 * Kop institusi: 2 baris, font Arial 11pt, left-aligned wrapper, text-center inside,
 * underline pada baris kedua dengan panjang SAMA seperti baris pertama.
 */
export function KopHeader({ line1 = "PUSAT PENDIDIKAN PENERBANGAN", line2 = "SATUAN PENDIDIKAN PERWIRA" }) {
  // Match longest line so underline has same width as line1 (top line is typically longer).
  return (
    <div style={{ marginBottom: 8, fontFamily: "Arial, sans-serif", fontSize: "11pt" }}>
      <div style={{ display: "inline-block", textAlign: "center" }}>
        <div style={{ whiteSpace: "nowrap", padding: "0 6px" }}>{line1}</div>
        <div style={{ whiteSpace: "nowrap", padding: "0 6px", borderBottom: "1px solid #000" }}>{line2}</div>
      </div>
    </div>
  );
}

/**
 * Blok TTD: nama TANPA underline, pangkat & NRP sejajar di bawah, format militer formal.
 */
export function TTDBlock({ lokasi, bulan, tahun, jabatan, nama, pangkat, nrp }) {
  return (
    <div style={{ marginTop: 30, display: "flex", justifyContent: "flex-end", fontFamily: "Arial, sans-serif", fontSize: "11pt" }}>
      <div style={{ width: 300, textAlign: "center" }}>
        <div>{lokasi}, {bulan} {tahun}</div>
        <div>{jabatan},</div>
        <div style={{ height: 70 }} />
        <div style={{ fontWeight: "bold" }}>{nama}</div>
        <div>{pangkat} NRP {nrp}</div>
      </div>
    </div>
  );
}
